export default __webpack_public_path__ + "static/media/NubMaduroBg.d90a1191.jpg";